import { render, staticRenderFns } from "./bulk-upload-popup.vue?vue&type=template&id=a2511440"
import script from "./bulk-upload-popup.vue?vue&type=script&lang=js"
export * from "./bulk-upload-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports